


























































































import Vue, { PropType } from "vue"
import PJobCategorySearchFilter from "./pcSearchKit/PJobCategorySearchFilter.vue"
import PPossibleOperatingMinHoursSearchFilter from "./pcSearchKit/PPossibleOperatingMinHoursSearchFilter.vue"
import PWorkingFormSearchFilter from "./pcSearchKit/PWorkingFormSearchFilter.vue"
import PSearchSort from "./pcSearchKit/PSearchSort.vue"
import SwitchButton from "~/components/guideline/search/SwitchButton.vue"
import TextField from "~/components/guideline/search/TextField.vue"
import FilterList from "~/components/guideline/search/FilterList.vue"
import FilterListItem from "~/components/guideline/search/FilterListItem.vue"
import BaseSearchModal from "~/components/custom/search/BaseSearchModal.vue"
import { SearchParams } from "~/clStores/projectSearchList"
import {
  JobCategoryOption,
  WorkingFormOption,
  SearchSortOption,
} from "~/clStores/projectSearchParameterOption"

type ModalType =
  | "JobCategoryFilter"
  | "PossibleOperatingMinHoursFilter"
  | "WorkingFormSearchFilter"
  | "SearchSort"

interface DataType {
  shownModalType: ModalType | null
  valueOnForm: SearchParams
}

export default Vue.extend({
  components: {
    SwitchButton,
    TextField,
    FilterList,
    FilterListItem,
    BaseSearchModal,
    PJobCategorySearchFilter,
    PPossibleOperatingMinHoursSearchFilter,
    PWorkingFormSearchFilter,
    PSearchSort,
  },
  props: {
    /**
     * 検索パラメータの値
     * v-modelで操作する。
     */
    value: {
      type: Object as PropType<SearchParams>,
      required: true,
    },
    jobCategoryOptions: {
      type: Array as PropType<JobCategoryOption[]>,
      required: true,
    },
    possibleOperatingMinHoursOptions: {
      type: Array as PropType<number[]>,
      required: true,
    },
    workingFormOptions: {
      type: Array as PropType<WorkingFormOption[]>,
      required: true,
    },
    searchSortOptions: {
      type: Array as PropType<SearchSortOption[]>,
      required: true,
    },
  },
  data(): DataType {
    return {
      /**
       * 表示する絞り込み用モーダルの種類
       */
      shownModalType: null,
      /**
       * フォーム上の検索パラメータ。
       * propsで渡されたvalueと同じ形式だが、検索の挙動としては値更新後に「絞り込む」ボタンをクリックすることで更新内容が検索一覧に反映されることになっており、
       * 仮にその前に絞り込みモーダルを閉じた場合は更新した内容は元に戻ることになっている。
       * そのため「絞り込む」ボタンを押される前の一時的な変更はvalueOnFormのみ変更することで再現している。
       */
      valueOnForm: this.value,
    }
  },
  computed: {
    jobCategoryFilterText(): string {
      // 1は選択された職種の数を表している。プロジェクトフィルターでは職種は1種類しか選択できない仕様のため、このように表示するようにしている。
      return this.value.largeJobCategoryIds.length > 0
        ? `職種：${this.value.largeJobCategoryIds.length}`
        : "職種"
    },
    possibleOperatingMinHoursFilterText(): string {
      // 選択された稼働時間範囲の最小値と最大値を取るために、稼働時間のリストを増加順でソート
      const sortedSelectedOptions = [
        ...this.value.possibleOperatingMinHours,
      ].sort((oneOption, anotherOption) => oneOption - anotherOption)

      if (sortedSelectedOptions.length === 0) {
        return "稼働時間"
      }

      return sortedSelectedOptions.length === 1
        ? `週${sortedSelectedOptions[0]}時間`
        : `週${sortedSelectedOptions[0]}時間〜週${
            sortedSelectedOptions[sortedSelectedOptions.length - 1]
          }時間`
    },
    workingFormSearchFilterText() {
      return this.value.workingFormIds.length > 0
        ? `リモート可否：${this.value.workingFormIds.length}`
        : "リモート可否"
    },
    searchSortText() {
      const selectedOption = this.searchSortOptions.find(
        (o) => o.value === this.value.orderByScore
      )
      return selectedOption ? `並び替え：${selectedOption.label}` : "並び替え"
    },
  },
  watch: {
    value() {
      this.valueOnForm = this.value
    },
  },
  methods: {
    handleInput(arg: SearchParams) {
      this.$emit("input", arg)
    },
    changeSearchWord(newVal: string) {
      this.handleInput({
        ...this.value,
        searchWord: newVal,
      })
    },
    openModal(modalType: ModalType) {
      this.shownModalType = modalType
    },
    closeModal() {
      this.valueOnForm = this.value // フォーム上の値を検索中のパラメーターで初期化
      this.shownModalType = null
    },
    clearJobCategory() {
      this.valueOnForm = {
        ...this.valueOnForm,
        largeJobCategoryIds: [],
      }
      this.handleSearch()
    },
    clearPossibleOperatingMinHours() {
      this.valueOnForm = {
        ...this.valueOnForm,
        possibleOperatingMinHours: [],
      }
      this.handleSearch()
    },
    clearWorkingForm() {
      this.valueOnForm = {
        ...this.valueOnForm,
        workingFormIds: [],
      }
      this.handleSearch()
    },
    clearSearchSort() {
      this.valueOnForm = {
        ...this.valueOnForm,
        orderByScore: true,
      }
      this.handleSearch()
    },
    handleSearch() {
      this.handleInput(this.valueOnForm)
      this.closeModal()
      this.$emit("search")
    },
  },
})
